export enum SnackbarStatus {
    SUCCESS = "SUCCESS",
    ERROR = "ERROR"
}